export const BRAND_PLACEHOLDER = '{brandName}'
